export default __webpack_public_path__ + "static/media/1490.4995a4a7.png";